export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.ad853713.svg";